import { createDrawerNavigator } from '@react-navigation/drawer';
import React, { useLayoutEffect, useState } from 'react';
import { Platform } from 'react-native';
import AppHeader from '../components/AppHeader';
import { useUserContext } from '../context/UserContext';
import DrawerScreen from '../screens/drawer/DrawerScreen';
import MessengerRoomScreen from '../screens/messenger/MessengerRoomScreen';
import MessengerRoomListScreen from '../screens/messenger/MessengerRoomListScreen';
import MyProfileSettings from '../screens/my-profile/MyProfileSettingsScreen';
import BottomTabNavigator from './BottomTabNavigator';
import ExamplesNavigator from './ExamplesNavigator';
import MyProfileSettingsNavigator from './MyProfileSettingsNav';

export type DrawerParamList = {
  MessengerRoomList: undefined;
  MessengerRoom: undefined;
  MyProfileSettingsNav: undefined;
  FormTemplate: {
    // formTemplateId or formTemplateName required
    formTemplateName?: string;
    formTemplateId?: number;
    entityDataId?: number; // provided if editing an existing form
    path?: string;
    sectionIndex?: number;
    backAnimation?: boolean;
    history?: string; // stringified array
    dataSourceFields?: string; //stringified array
    studyParticipantId?: number;
    fromStudyScreen?: boolean;
  };
  SurveyFormDateInputExample: undefined;
  SurveyFormSelectExample: undefined;
  SurveyFormInputExample: undefined;
  SurveyFormMultipleChoiceExample: undefined;
  SurveyFormSliderExample: undefined;
  LocalNotificationTest: undefined;
  PreScreeningSurvey: undefined;
  IntakeSurvey: undefined;
  DemographicsAndMedicalHistorySurvey: undefined;
  MedicalOutcomesStudySleepScaleSurvey: undefined;
  GeneralizedAnxietyDisorderSurvey: undefined;
  InsomniaSeverityIndexSurvey: undefined;
  StudyDoseSurvey: undefined;
  ExitSurvey: undefined;
  ConsentScreen: undefined;
  DataTrackerChartScreen: undefined;
  CompareChartScreen: undefined;
  GaugeChartScreen: undefined;
  TestDynamicFormScreen:
    | {
        path?: string;
        sectionIndex?: number;
        // currentValues?: any;
        backAnimation?: boolean;
      }
    | undefined;
  CalendarScreen: undefined;
  Study1ResultsExampleScreen: undefined;
  Study2ResultsExampleScreen: undefined;
  BottomTabNav: undefined;
  ExamplesNavigator: undefined;
};

const Drawer = createDrawerNavigator<DrawerParamList>();

export default function DrawerNavigator() {
  const { user } = useUserContext();
  // Work Around For Flickering drawer layout for web
  const [initRender, setInitRender] = useState<'back' | 'front' | undefined>();
  useLayoutEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    if (Platform.OS === 'web') {
      setInitRender('back');
      timeout = setTimeout(() => {
        setInitRender('front');
      }, 350);
    } else {
      setInitRender('back');
    }

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Drawer.Navigator
      initialRouteName='BottomTabNav'
      screenOptions={{
        header: () => <AppHeader />,
        drawerPosition: 'right',
        drawerType: initRender,
        headerShown: !!user,
        swipeEnabled: false,
        overlayColor: 'transparent',
        drawerStyle: { marginTop: 69 }
      }}
      drawerContent={props => <DrawerScreen {...props} />}
    >
      <Drawer.Screen
        options={{ headerShown: false }}
        name='BottomTabNav'
        component={BottomTabNavigator}
      />
      <Drawer.Screen
        name='MessengerRoomList'
        component={MessengerRoomListScreen}
      />
      <Drawer.Screen name='MessengerRoom' component={MessengerRoomScreen} />
      <Drawer.Screen
        name='MyProfileSettingsNav'
        component={MyProfileSettingsNavigator}
      />
      <Drawer.Screen name='ExamplesNavigator' component={ExamplesNavigator} />
    </Drawer.Navigator>
  );
}
